import { FC } from 'react';
import classNames from 'classnames';

import { i18n as I18n } from 'utils/i18n';

const classes = classNames(
  'booking-slot__btn',
  'booking-slot__btn--unavailable',
  'booking-slot__btn--no-times'
);

interface Props {
  length?: number;
  width?: number;
  offset?: number;
  label?: string;
}

const ClosedSlot: FC<Props> = ({
  length = 16,
  width = 50,
  offset = 0,
  label = I18n.t('shared.closed'),
}) => {
  const wrapperStyle = {
    position: 'absolute',
    left: `${offset}px`,
    width: `${length * width}px`,
    top: '3.5rem',
  };

  return (
    <span style={wrapperStyle}>
      <button className={classes} disabled>
        {label}
      </button>
    </span>
  );
};

export default ClosedSlot;
